import * as types from '../mutation-types'

export default {
	namespaced: true,
	state: {
		filters: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/filters').then(({ data }) => {
				commit(types.STORE_FILTERS, data);
				return data;
			})
		},
		create({ commit }, { name }) {
			return axios.post('/filters', { name })
		},
		update({ commit }, { id, name }) {
			return axios.post(`/filters/update/${id}`, { name, _method: 'PUT' })
		},
		delete({ commit }, { id }) {
			return axios.delete(`/filters/${id}`)
		},
		restore({ commit }, { id }) {
			return axios.patch(`/filters/${id}`)
		},
	},

	mutations: {
		[types.STORE_FILTERS](state, filters) {
			state.filters = filters;
		}
	},

	getters: {
		getFilterById: state => id => state.filters.find(c => c.id === id),
		getFilterBySlug: state => slug => state.filters.find(c => c.slug === slug),
	}
}